module.exports = __webpack_public_path__ + "img/AppBuilderLogo.dc0a1b88.jpg";